import angular from "angular";

import _ from "lodash";

import moment from "moment";

/**
 * @class
 * Classe cuida dos series do chart
 */
export class ChartSeries {
    constructor(ColorService, ChartHelper) {
        this.types = {
            area: this.temporalSeries,
            arearange: this.temporalSeries,
            areaspline: this.temporalSeries,
            bar: this.temporalSeries,
            column: this.temporalSeries,
            columncomparation: this.nameValueComparation,
            columnrange: this.temporalSeries,
            line: this.temporalSeries,
            spline: this.temporalSeries,
            pie: this.nameValue,
            variablepie: this.nameValue,
            scatter: -1,
            funnel: 4,
            pyramid: 4,
            gauge: this.nameValue,
            solidgauge: 2,
            waterfall: this.nameValue,
            donut: this.donut,
            combinations: this.temporalSeries
        };

        this.ColorService = ColorService;
        this.ChartHelper = ChartHelper;
    }

    /**
     * @private
     * Formata de acrodo com a necessidade dos gráficos
     * @param {Object} date
     * @param {Boolean} parse
     * @returns {Object} date
     */
    _formatDate = (date, parse = false) => {
        date = moment(date).utcOffset(0).startOf("month").format("x");

        return parse ? parseInt(date) : date;
    };

    /**
     * @private
     *
     * @param {Object} dates
     * @return {Array}
     */
    _getDates = (dates = this.dates) => {
        if (!dates) return;

        return dates.map((date) => this._formatDate(date));
    };

    /**
     * @private
     * @param {String} _id
     * @returns {Object}
     */
    _getSerie = (_id) => {
        return _.find(this.series, (serie) => serie._id == _id);
    };

    /**
     * @private
     * @param {String} _id
     * @returns {Object}
     */
    _getColor = (color) => {
        return this.ColorService.colorByPath(color);
    };

    /**
     * @private
     * Faz união de duas series
     * @param {Array} seriesWithPoints series gerada pela DaMa
     * @param {Array} seriesChart series gerada pelo chart dentro do BD
     * @returns {Array}
     */
    _mergeSeries = (seriesWithPoints, seriesChart = this.seriesDefault) => {
        seriesWithPoints = [].concat(seriesWithPoints);

        seriesWithPoints = seriesWithPoints.map((serie) => {
            let defaultSerie = seriesChart.find(
                (serieChart) => serieChart._id == serie._id
            );
            defaultSerie = angular.copy(defaultSerie);
            if (defaultSerie) {
                const color = this._getColor(defaultSerie.color);
                if (color) defaultSerie.color = color;
            }
            _.unset(defaultSerie, "data");
            return Object.assign(serie, defaultSerie);
        });

        return seriesWithPoints;
    };

    /**
     * @public
     * Cria series temporais
     * @returns {Object}
     * @returns {Array}
     */
    temporalSeries = () => {
        if (!this.points) return;
        this.points = this.points.filter((p) => p);
        if (_.isEmpty(this.points)) return;

        const series = this.points.map((point) => {
            const serie = this._getSerie(point.ds) || {};

            const _id = serie._id;
            const name = serie.name;
            const unit = serie.unit;
            const isDisabled = _.get(serie, "metadata.disabled") || false;

            const path = point.p || point.r;
            if (path) {
                point.data = path.map((p) => {
                    if (
                        ["yearly", "quarterly", "semester"].includes(
                            this.period
                        )
                    )
                        return p.v;

                    return {
                        y: isDisabled ? 0 : p.v,
                        x: this._formatDate(p.t, true)
                    };
                });
            } else point.data = [];

            return {
                _id,
                name,
                unit,
                data: point.data
            };
        });

        return this._mergeSeries(series);
    };

    /**
     * @private
     * Retorna um array com uma posição contendo as seires
     * @returns {Array}
     */
    _singleData = () => {
        return this.points.map((point) => {
            const { _id, name, unit } = this._getSerie(point.ds);

            return {
                _id,
                name,
                unit,
                y: _.get(_.last(point.p), "v") || 0
            };
        });
    };

    /**
     * @private
     * Retorna um array com uma possição
     * @returns {Array}
     */
    nameValue = () => {
        let data = this._singleData();

        data = this._mergeSeries(data);

        data = _.sortBy(data, "i");

        if (this.type == "pie") _.remove(data, (v) => v.y < 0);

        return [
            {
                key: true,
                name: null,
                data
            }
        ];
    };

    /**
     * @public
     * Função formata de acordo com o Fonte de Recursos
     * @returns {Array}
     */
    nameValueComparation = () => {
        const series = this.points.map((point) => {
            const { _id, name } = this._getSerie(point.ds);

            const seriesDefault =
                _.find(this.seriesDefault, { _id: point.ds }) || {};

            return {
                _id,
                data: [
                    {
                        y: _.get(_.last(point.p), "v"),
                        color: seriesDefault.color,
                        name
                    }
                ],
                stack: seriesDefault.stack,
                type: seriesDefault.type
            };
        });

        return series;
    };

    /**
     * @private
     * @param {Number} valor a ser destacada
     * @param {Stirng} unit unidade a ser representada
     *
     */
    _setText(num, unit) {
        this.text = { text: this.ChartHelper.formatValue(unit, num) };
    }

    /**
     * @private
     * Retorna o valor que deve ser destacado
     * @returns {Object} { text: 100 }
     */
    _getText() {
        return this.text;
    }

    /**
     * @private
     * Retona array
     *
     * @return
     */
    donut = () => {
        let [serie] = this._singleData();

        if (!serie) return;

        this._setText(serie.y, serie.unit);

        serie.y = serie.y / 100;

        let data = [
            { y: Math.abs(serie.y) },
            {
                y: 1 - Math.abs(serie.y)
            }
        ];

        serie.data = data;

        serie.data = serie.y < 0 ? data.reverse() : data;

        const [donutSeriesDefault] = this.seriesDefault;

        if (donutSeriesDefault.data) {
            serie.data = _.merge(data, donutSeriesDefault.data);
        }

        serie.data = serie.y < 0 ? serie.data.reverse() : serie.data;

        serie = this._mergeSeries(serie);

        return serie;
    };

    /**
     * @public
     *
     * @param {String}
     */
    format = (
        series,
        points,
        dates,
        seriesDefault = [],
        type,
        period,
        rewriteCategories = false
    ) => {
        this.points = points;
        this.series = series;

        this.dates = this._getDates(dates);
        this.type = type;

        this.period = period;

        this.seriesDefault = seriesDefault;
        this.rewriteCategories = rewriteCategories;

        if (this.types[type]) {
            return this.types[type]();
        }

        return this.temporalSeries();
    };
}

angular
    .module("nucont.shared")
    .service("ChartSeries", ["ColorService", "ChartHelper", ChartSeries]);
